import styled from 'styled-components';

export const Container = styled.div`
  .row.abastecimento {
    display: grid;
    grid-template-columns: 35.5rem 2fr;
    grid-gap: 1.5rem;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }

  .row.mensagens {
    display: grid;
    grid-template-columns: 35.5rem 2fr;
    grid-gap: 1.5rem;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }
`;
